import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "emailInput", "errorTextContainer" ]
  static values = { email: String }

  submit(event) {
    event.preventDefault()

    if (this.emailInputTarget.value !== this.emailValue) {
      this.errorTextContainerTarget.classList.remove("hidden!")
      this.errorTextContainerTarget.textContent = "invalid email"

      return
    }

    event.target.closest("form").requestSubmit()
  }
}
